if (!customElements.get('eds-category-comparison')) {
  customElements.define(
    'eds-category-comparison',
    class EDSCategoryComparison extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.scrollArea = this.querySelector('[data-comparison-scroll]');
        this.previousButton = this.querySelector('[data-comparison-previous]');
        this.nextButton = this.querySelector('[data-comparison-next]');
        if (!this.scrollArea || !this.previousButton || !this.nextButton) return;

        this.onScroll = this.updateNavigation.bind(this);
        this.onResize = this.updateNavigation.bind(this);
        this.onPrevious = () => this.scrollByColumn(-1);
        this.onNext = () => this.scrollByColumn(1);

        this.previousButton.addEventListener('click', this.onPrevious);
        this.nextButton.addEventListener('click', this.onNext);
        this.scrollArea.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.initialized = true;
        this.updateNavigation();
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.previousButton.removeEventListener('click', this.onPrevious);
        this.nextButton.removeEventListener('click', this.onNext);
        this.scrollArea.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.initialized = false;
      }

      scrollByColumn(direction) {
        const column = this.querySelector('.eds-category-comparison__competitor-column');
        const distance = column ? column.getBoundingClientRect().width : 150;
        this.scrollArea.scrollBy({ left: direction * distance, behavior: 'smooth' });
      }

      updateNavigation() {
        const maximumScroll = this.scrollArea.scrollWidth - this.scrollArea.clientWidth;
        const canScroll = maximumScroll > 1;
        this.previousButton.disabled = !canScroll || this.scrollArea.scrollLeft <= 1;
        this.nextButton.disabled = !canScroll || this.scrollArea.scrollLeft >= maximumScroll - 1;
      }
    }
  );
}
